import styled from 'styled-components';

import { paragraphs } from '@proprioo/salatim';

export const Message = styled.div`
  ${paragraphs.bodyLight1};
  text-align: center;
`;
